import React from 'react';
import T from 'prop-types';
import Field from 'shared/components/field';
import { Select } from '@acast/decibel';

const ShowSelectField = ({ onChange, meta, propName, label, help, value, options }) => {
  return (
    <Field name={propName} label={label} meta={meta} help={help}>
      <Select onChange={event => onChange(event.target.value)} value={value || ''}>
        {options.map(option => (
          <Select.Option key={option.value} value={option.value} disabled={option.disabled}>
            {option.label}
          </Select.Option>
        ))}
      </Select>
    </Field>
  );
};

ShowSelectField.propTypes = {
  onChange: T.func,
  meta: T.object,
  propName: T.string,
  label: T.string,
  help: T.node,
  value: T.any,
  options: T.array,
};

export default ShowSelectField;
